<template>
    <div>
        <div class="container py-3">
            <div class="breadcrumbs-retos">
                <a href="/home-bat">
                    <img src="/img/icons/homeBread.svg" alt="" />
                </a>
                <span class="link color-active-miga"><strong>Preguntas frecuentes</strong></span>
            </div>

            <div class="header-portfolio d-flex flex-column pt-2">
                <h5>¿Tienes dudas?</h5>
                <span>Resuélvelas aquí, si no encuentras alguna, no dudes en contactar a Victoria</span>
            </div>
        </div>

        <div>
            <div v-if="!findSegment(client_segment)" class="row justify-content-center mb-5">
                <div class="col-12 col-md-9 container-flex">
                    <div class="accordion accordion-flush" id="headerAcordion">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingOne">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseOne" aria-expanded="false"
                                    aria-controls="flush-collapseOne">
                                    <p>¿En qué consiste el programa Conecta2?</p>
                                </button>
                            </h2>
                            <div class="accordion-collapse collapse" id="flush-collapseOne"
                                aria-labelledby="flush-headingOne" data-bs-parent="#headerAcordion ">
                                <div class="accordion-body">
                                    <p>Es el programa de fidelización de British American Tobacco Colombia S.A.S., diseñado especialmente para que usted, Amigo Tendero, refuerce sus conocimientos y aprenda cosas nuevas, potencialice su negocio y mejore la relación con sus clientes.</p>
                                    <p>Usted tendrá acceso a contenido ilustrativo, donde se le compartirán consejos útiles para
                                        mejorar su negocio y sus conocimientos. Además, contamos con alianzas para usted y su familia y un canal de comunicaciones de todas las primicias para que esté al tanto de todo.
                                    </p>
                                    <p>Un embajador estará visitándolo con el fin de apoyarlo y solucionarle las dudas que tenga sobre el programa de CONECTA2, así mismo, cuenta con una Plataforma que le brindará todo el aprendizaje necesario para su negocio, un chat en línea de la plataforma conectados o la línea 018000122040, donde podrán atender todas sus dudas e inquietudes, recibir comunicación e información importante.</p>
                                    <p>Si cumple los módulos de aprendizaje y responde correctamente los retos, podrá animarse a seguir aprendiendo.</p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingTwo">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseTwo" aria-expanded="false"
                                    aria-controls="flush-collapseTwo">
                                    <p>¿Cómo gano en el programa Conecta2?</p>
                                </button>
                            </h2>
                            <div class="accordion-collapse collapse" id="flush-collapseTwo"
                                aria-labelledby="flush-headingTwo" data-bs-parent="#headerAcordion ">
                                <div class="accordion-body">
                                    <p>Los avances se llevarán a cabo de forma mensual después del cierre del mes. Si bien para obtener las retribuciones, los tenderos deben cumplir con todas las métricas. Hay diferentes indicadores que se medirán y tendrán asignado un porcentaje específico, el cual determinará cuánto se va a ganar el punto de venta por el avance de ese indicador en particular.</p>
                                    <p>La recompensa se entregará como un acto de mera liberalidad, será temporal y se aplicará en observancia de las normativas y restricciones aplicables a cada uno de los productos, y será generada siempre y cuando no resulte contraria a éstas.</p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingThree">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseThree" aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    <p>¿A dónde puedo comunicarme si tengo inquietudes?</p>
                                </button>
                            </h2>
                            <div class="accordion-collapse collapse" id="flush-collapseThree"
                                aria-labelledby="flush-headingThree" data-bs-parent="#headerAcordion ">
                                <div class="accordion-body">
                                    <p>
                                        Contamos con una línea de atención, donde la señora Victoria Guerrero estará disponible para aclarar todas las dudas que tenga con el programa e inconvenientes con la plataforma. Puede comunicarse a través de nuestro chat en línea de la plataforma Conecta2 o llamando a nuestras líneas de atención 018000122040 y al #551 para solucionar todas sus inquietudes.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingFive">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseFive" aria-expanded="false"
                                    aria-controls="flush-collapseFive">
                                    <p>No puedo ingresar a la plataforma Conecta2</p>
                                </button>
                            </h2>
                            <div class="accordion-collapse collapse" id="flush-collapseFive"
                                aria-labelledby="flush-headingFive" data-bs-parent="#headerAcordion ">
                                <div class="accordion-body">
                                    <p>Recuerde que su usuario es su cédula. ¿Olvidó su contraseña? Por favor ingrese en la opción de “olvidé contraseña” y siga los pasos para volverla a crear. En caso de que no le funcione, comuníquese con nuestro chat en línea de la plataforma conectados o llame a la línea 018000122040.</p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingSix">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseSix" aria-expanded="false"
                                    aria-controls="flush-collapseSix">
                                    <p>Me sacaron del plan y yo tengo todo en regla</p>
                                </button>
                            </h2>
                            <div class="accordion-collapse collapse" id="flush-collapseSix"
                                aria-labelledby="flush-headingThree" data-bs-parent="#headerAcordion ">
                                <div class="accordion-body">
                                    <p>Para sacarlo del programa tuvo que haber recibido una carta en la que se explicaron las razones de su salida del programa. Si tiene dudas contacte a su embajador para mayor claridad.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else class="row justify-content-center mb-5">
                <div class="col-12 col-md-9 container-flex">
                    <div class="accordion accordion-flush" id="headerAcordion">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingOne">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseOne" aria-expanded="false"
                                    aria-controls="flush-collapseOne">
                                    <p>¿Cómo acumulo puntos?</p>
                                </button>
                            </h2>
                            <div class="accordion-collapse collapse" id="flush-collapseOne"
                                aria-labelledby="flush-headingOne" data-bs-parent="#headerAcordion ">
                                <div class="accordion-body">
                                    <p>Todos los meses te indicarán tus objetivos los cuales están asociados a variables. Estas variables representan puntos que si logras completar se cargarán en tu usuario en las próximas dos semanas después del cierre. Tus puntos se redimen en premios disponibles en tu catálogo Conecta2 Contigo.</p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingTwo">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseTwo" aria-expanded="false"
                                    aria-controls="flush-collapseTwo">
                                    <p>¿Cuándo sé el valor en puntos y las variables que participan ese mes?</p>
                                </button>
                            </h2>
                            <div class="accordion-collapse collapse" id="flush-collapseTwo"
                                aria-labelledby="flush-headingTwo" data-bs-parent="#headerAcordion ">
                                <div class="accordion-body">
                                    <p>Cada Area Manager te informará, la primera semana del mes, cuáles son las variables incluidas y el valor de las mismas en puntos para la plataforma que más te hace ganar.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingThree">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseThree" aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    <p>¿Por qué mi gestión en plataforma no coincide con el real?</p>
                                </button>
                            </h2>
                            <div class="accordion-collapse collapse" id="flush-collapseThree"
                                aria-labelledby="flush-headingThree" data-bs-parent="#headerAcordion ">
                                <div class="accordion-body">
                                    <p>Tenemos un período de dos semanas en las que se irán actualizando las variables, de acuerdo al proceso de devolución.</p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingFour">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseFour" aria-expanded="false"
                                    aria-controls="flush-collapseFour">
                                    <p>Ya elegí los premios y redimí mis puntos ¿a dónde me llegan los
                                        premios?</p>
                                </button>
                            </h2>
                            <div class="accordion-collapse collapse" id="flush-collapseFour"
                                aria-labelledby="flush-headingThree" data-bs-parent="#headerAcordion ">
                                <div class="accordion-body">
                                    <p>Al registrarte en la plataforma e incluir tus datos indica la dirección en la que quieres recibir tus premios. Un proveedor de transporte enviará a ese domicilio tu premio en un período de 10 días hábiles, en caso de que nadie lo reciba lo enviaremos a la sucursal. Recuerda mantener actualizado tu domicilio. En caso de que no hayas incluido ninguna dirección, tus premios se enviarán a la sucursal.</p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingFive">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseFive" aria-expanded="false"
                                    aria-controls="flush-collapseFive">
                                    <p>¿Cómo funcionan los bonos digitales?</p>
                                </button>
                            </h2>
                            <div class="accordion-collapse collapse" id="flush-collapseFive"
                                aria-labelledby="flush-headingFive" data-bs-parent="#headerAcordion ">
                                <div class="accordion-body">
                                    <p>Tus puntos también pueden ser redimidos por bonos digitales que recibirás en tu teléfono y tu correo en un día. Recuerda que Homecenter, Cencosud, Éxito, Aviatur, Falabella entre otros, son empresas en las que podrás usarlos. No te pierdas de nada mantén tus datos al día.</p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingSix">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseSix" aria-expanded="false"
                                    aria-controls="flush-collapseSix">
                                    <p>¿Cómo actualizo mis datos?</p>
                                </button>
                            </h2>
                            <div class="accordion-collapse collapse" id="flush-collapseSix"
                                aria-labelledby="flush-headingThree" data-bs-parent="#headerAcordion ">
                                <div class="accordion-body">
                                    <p>Si requieres incluir y/o actualizar tus datos accede a tu nombre en la parte superior derecha de la pantalla. Haz clic en el menú y selecciona la opción Actualizar mis datos. Realiza los cambios correspondientes.</p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingSeven">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseSeven" aria-expanded="false"
                                    aria-controls="flush-collapseSeven">
                                    <p class="m-0">¿Puedo elegir cualquier premio?</p>
                                </button>
                            </h2>
                            <div class="accordion-collapse collapse" id="flush-collapseSeven"
                                aria-labelledby="flush-headingSeven" data-bs-parent="#headerAcordion ">
                                <div class="accordion-body">
                                    <p>Con tus puntos puedes elegir cualquier premio. Sólo verifica que cuente con inventario y que tus puntos acumulados sean iguales o superiores al valor en puntos del premio.</p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingEight">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseEight" aria-expanded="false"
                                    aria-controls="flush-collapseEight">
                                    <p>¿Puedo revisar mi historial de puntos?</p>
                                </button>
                            </h2>
                            <div class="accordion-collapse collapse" id="flush-collapseEight"
                                aria-labelledby="flush-headingEight" data-bs-parent="#headerAcordion ">
                                <div class="accordion-body">
                                    <p>Sí. En la parte superior derecha de la pantalla, en donde aparece tu nombre, haz clic en el menú y accede a la sección puntos, allí veras tu historia de puntos acumulados y redimidos en la fecha correspondiente.</p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingNine">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseNine" aria-expanded="false"
                                    aria-controls="flush-collapseNine">
                                    <p>¿Qué es la sección Alianzas?</p>
                                </button>
                            </h2>
                            <div class="accordion-collapse collapse" id="flush-collapseNine"
                                aria-labelledby="flush-headingNine" data-bs-parent="#headerAcordion ">
                                <div class="accordion-body">
                                    <p>En la sección Alianzas conocerás las condiciones del proveedor participante. Verifica los puntos de venta presenciales para redención. Accede a obtener cupón y obtendrás tu código de redención. Acude con tu cédula.</p>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingTen">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseTen" aria-expanded="false"
                                    aria-controls="flush-collapseTen">
                                    <p>¿A dónde puedo comunicarme si tengo inquietudes?</p>
                                </button>
                            </h2>
                            <div class="accordion-collapse collapse" id="flush-collapseTen"
                                aria-labelledby="flush-headingTen" data-bs-parent="#headerAcordion ">
                                <div class="accordion-body">
                                    <p>
                                        Contamos con una línea de atención, donde la señora Victoria Guerrero estará
                                        disponible para aclarar todas las dudas que tenga con el programa e inconvenientes con la plataforma. Puede comunicarse a través de
                                        nuestro chat en línea de la plataforma Conecta2 o llamando a nuestras líneas de atención 018000122040 y al #551 para solucionar
                                        todas sus inquietudes.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        client_segment: {
            type: Number,
            default: 0,
        },

        user_segments: {
            default: [],
        }
    },

    methods: {
        findSegment(client_segment) {
            for (let i = 0; i < this.user_segments.length; i++) {
                if (this.user_segments[i].includes(client_segment)) {
                    return true;
                }
            }
            return false;
        },
    }
}
</script>